import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["leftButton", "rightButton"]

  connect() {
    this.checkScrollPosition()
    this.element.closest("#hotel-nav").querySelector("#scrollable-navbar")
      ?.addEventListener("scroll", () => this.checkScrollPosition())
  }

  checkScrollPosition() {
    const container = this.element.closest("#hotel-nav").querySelector("#scrollable-navbar")
    if (!container) return

    const isAtStart = container.scrollLeft <= 0
    const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth

    this.leftButtonTarget.classList.toggle("opacity-50", isAtStart)
    this.leftButtonTarget.classList.toggle("cursor-not-allowed", isAtStart)
    this.rightButtonTarget.classList.toggle("opacity-50", isAtEnd)
    this.rightButtonTarget.classList.toggle("cursor-not-allowed", isAtEnd)
  }

  scrollRight() {
    const container = this.element.closest("#hotel-nav").querySelector("#scrollable-navbar")
    if (container && !this.isAtEnd(container)) {
      container.scrollTo({
        left: container.scrollLeft + 200,
        behavior: "smooth"
      })
    }
  }

  scrollLeft() {
    const container = this.element.closest("#hotel-nav").querySelector("#scrollable-navbar")
    if (container && !this.isAtStart(container)) {
      container.scrollTo({
        left: container.scrollLeft - 200,
        behavior: "smooth"
      })
    }
  }

  isAtStart(container) {
    return container.scrollLeft <= 0
  }

  isAtEnd(container) {
    return container.scrollLeft + container.clientWidth >= container.scrollWidth
  }
}